/**
 * Umami-analytics (självhostad, cookiefri).
 *
 * Ersätter tidigare Google Analytics (gtag) + cookie-banner. Umami sätter inga
 * cookies och lagrar ingen personidentifierande data, därför behövs inget
 * samtycke enligt GDPR/ePrivacy – hela consent-flödet kunde tas bort.
 *
 * Website-ID skapas i Umami-adminen (https://analytics.lconsulting.se) och kan
 * antingen sättas här eller via env-variabeln REACT_APP_UMAMI_WEBSITE_ID vid
 * build. Utan ID laddas ingen tracking (t.ex. lokalt/dev).
 */

const UMAMI_SCRIPT_URL = 'https://analytics.lconsulting.se/script.js';
const UMAMI_WEBSITE_ID = process.env.REACT_APP_UMAMI_WEBSITE_ID || '';

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, unknown>) => void;
    };
  }
}

function isEnabled(): boolean {
  if (!UMAMI_WEBSITE_ID) return false;
  if (process.env.NODE_ENV !== 'production') return false;
  // Spåra inte lokala testinstanser även om en produktionsbuild körs lokalt.
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return false;
  return true;
}

/** Injicerar Umamis tracking-script. Anropas en gång vid appstart (App.tsx). */
export function initUmami(): void {
  if (!isEnabled()) return;
  if (document.querySelector(`script[src="${UMAMI_SCRIPT_URL}"]`)) return;
  const script = document.createElement('script');
  script.src = UMAMI_SCRIPT_URL;
  script.defer = true;
  script.setAttribute('data-website-id', UMAMI_WEBSITE_ID);
  document.head.appendChild(script);
}

/**
 * Spårar ett custom event i Umami. No-op om tracking inte är aktiv eller
 * scriptet inte hunnit ladda – får aldrig påverka spelet.
 */
export function trackEvent(event: string, data?: Record<string, unknown>): void {
  try {
    window.umami?.track(event, data);
  } catch {}
}
